"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTokenByText = void 0;
/**
 * The method "replaceTokenByText" will replace a token with pattern "##token##" by the provided
 * value or the provided default value
 *
 * @param text
 * @param token
 * @param defaultValue
 * @param value
 * @returns
 */
const replaceTokenByText = (text, token, defaultValue, value) => text.replaceAll(token, value || defaultValue);
exports.replaceTokenByText = replaceTokenByText;
